import { i18n } from '../main'

import exploreImage from '../assets/onboarding/il_Onboarding_Explore.svg'
import resourcesImage from '../assets/onboarding/il_Onboarding_resources.svg'
import foldersImage from '../assets/onboarding/il_Onboarding_Folders.svg'
import programsImage from '../assets/onboarding/il_Onboarding_Programs.svg'
import metricsImage from '../assets/onboarding/il_Onboarding_Metrics.svg'

// onboardingSteps is a function in order to make i18n work.
export const onboardingSteps = () => [
  {
    id: 'onboarding-step-0',
    target: '#v-step-0',
    content: i18n.t('onboarding.explore'),
    image: exploreImage
  },
  {
    id: 'onboarding-step-1',
    target: '#RecommendedResource-0',
    content: i18n.t('onboarding.resource'),
    image: resourcesImage,
    params: {
      enableScrolling: false,
      placement: 'right'
    }
  },
  {
    id: 'onboarding-step-2',
    target: '#v-step-2',
    content: i18n.t('onboarding.folders'),
    image: foldersImage
  },
  {
    id: 'onboarding-step-3',
    target: '#v-step-3',
    content: i18n.t('onboarding.programs'),
    image: programsImage
  },
  {
    id: 'onboarding-step-4',
    target: '#v-step-4',
    content: i18n.t('onboarding.statistics'),
    image: metricsImage
  }
]
